import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { GetRetuenPayrollBo } from './payroll.model';
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root'
  })

export class PaidHTTPService extends Subject<DataStateChangeEventArgs>{
  originaldata: any = [];
  childData: any = [];
  idlist: any = [];
  public details: any = [];
  errorlist: any = [];
  serialno: any;
  constructor(private http: HttpClient, private ngxService: NgxUiLoaderService,public datePipe: DatePipe, public errorService: ErrorService, public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public executepaid(state: GetRetuenPayrollBo): void {
    this.getPaidList(state).subscribe(M => super.next(M));
  }
  getPaidList(state?: GetRetuenPayrollBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Payroll/GetPaidPayroll", state)
      .map(
        (response: any) =>
        (<any>{
          count: response['count'],
          result: response['paidPayrollBO'],
         
          
        }
        )
      ).map((e: any) => {
        e.result = this.setdata(e);
        console.log(e,"eeeeeeeee")
        return e;
      })
  }



  setdata(data) {
    console.log(data,"ddddddddddddddd");
    let parentArray = [];
    let childArray = [];
    if (data.result.length != 0) {


      data.result.forEach(element => {
        let obj =
        {
          'id':element.payrollId,
          'employeeId': element.employeeId,
          'employeeName': element.employeeName,
          'clientId': element.clientId,
          'clientName': element.clientName,
          'serviceName':element.serviceName,
          'payrate':element.payrate,
          'serviceDate': this.datePipe.transform(element.serviceDate, "MM/dd/yyyy"),
          'timesheetId':element.timesheetId,
          'totalAmount':  element.totalAmount,
          'hours': element.hours,
          'payDate':element.payDate,
           'isApproved':element.isApproved,
        }
        parentArray.push(obj);
      });
      data.result.forEach(element => {
        let obj1 =
        {
          'employeeId': element.unPaidPayrollBO.employeeId,
          'employeeName': element.unPaidPayrollBO.employeeName,
          'clientId': element.unPaidPayrollBO.clientId,
          'clientName': element.unPaidPayrollBO.clientName,
          'serviceName':element.unPaidPayrollBO.serviceName,
          
          'rate':(element.unPaidPayrollBO.payrollPayRateBO==null||element.unPaidPayrollBO.payrollPayRateBO==undefined)?0:element.unPaidPayrollBO.payrollPayRateBO.rate,
          'serviceDate': this.datePipe.transform(element.unPaidPayrollBO.serviceDate, "MM/dd/yyyy"),
          'timesheetId':element.unPaidPayrollBO.timesheetId,
          'totalAmount':(element.unPaidPayrollBO.payrollPayRateBO==null||element.unPaidPayrollBO.payrollPayRateBO==undefined)?0: element.unPaidPayrollBO.payrollPayRateBO.totalAmount,
          'hours': element.unPaidPayrollBO.hours,
          'isApproved':element.isApproved
        }
        childArray.push(obj1);
      });
      this.childData = childArray;
    
    }
    
    
     


    else {
      parentArray = []
      this.childData = [];
    }
    return parentArray;
  }

  getChildData() {
    return this.childData;

  }

}




